import { dataTextSquareAltSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTextSquareAltSolid = /*#__PURE__*/createIcon(dataTextSquareAltSolid)
export default IconTextSquareAltSolid
